/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SearchProductsRequest = {
  /**
   * The page number for pagination.
   */
  pageNumber?: number | undefined;
  /**
   * The number of items per page.
   */
  pageSize?: number | undefined;
};

/** @internal */
export const SearchProductsRequest$inboundSchema: z.ZodType<
  SearchProductsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  page_number: z.number().default(1),
  page_size: z.number().default(10),
}).transform((v) => {
  return remap$(v, {
    "page_number": "pageNumber",
    "page_size": "pageSize",
  });
});
/** @internal */
export type SearchProductsRequest$Outbound = {
  page_number: number;
  page_size: number;
};

/** @internal */
export const SearchProductsRequest$outboundSchema: z.ZodType<
  SearchProductsRequest$Outbound,
  z.ZodTypeDef,
  SearchProductsRequest
> = z.object({
  pageNumber: z.number().default(1),
  pageSize: z.number().default(10),
}).transform((v) => {
  return remap$(v, {
    pageNumber: "page_number",
    pageSize: "page_size",
  });
});

export function searchProductsRequestToJSON(
  searchProductsRequest: SearchProductsRequest,
): string {
  return JSON.stringify(
    SearchProductsRequest$outboundSchema.parse(searchProductsRequest),
  );
}
export function searchProductsRequestFromJSON(
  jsonString: string,
): SafeParseResult<SearchProductsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SearchProductsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SearchProductsRequest' from JSON`,
  );
}
